<div *ngIf="!params.compactMode; else compactChipsInput">
  <cm-text-input
    [formControl]="formControl"
    (keyup.enter)="addValue()"
    [class.is-invalid]="isFormError()"
    (blur)="addValue()"
    [placeholder]="placeholder">
  </cm-text-input>

  <div class="error-message" *ngIf="isFormError() && errorMessage as error">{{error}}</div>

  <cm-chips
    class="chips"
    [options]="selectedValues"
    (removeLabel)="!formControl.disabled && removeValue($event)"
  ></cm-chips>
</div>

<ng-template #compactChipsInput>
  <cm-chips
    class="chips-input-wrapper"
    [ngClass]="{disabled: formControl.disabled, 'is-invalid': isFormError()}"
    [options]="selectedValues"
    (removeLabel)="!formControl.disabled && removeValue($event)"
  >
    <cm-text-input
      [autocomplete]="false"
      [formControl]="formControl"
      (keyup.enter)="addValue()"
      class="chip-input"
      (blur)="addValue()"
      [placeholder]="placeholder">
    </cm-text-input>
  </cm-chips>
  <div class="error-message" *ngIf="isFormError() && errorMessage as error">{{error}}</div>
</ng-template>
